module.exports = __webpack_public_path__ + "static/media/nbc.3d19489b.png";